module.exports = __webpack_public_path__ + "@/assets/img/gocuotaslogo.b95a2a9f.png";